import { useFragment } from 'react-relay';
import { detailFilterSelectionInfoFragment } from './DetailFilterSelectionInfo.relay';
import type { DetailFilterSelectionInfoPropsType } from './types';

const DetailFilterSelectionInfo: React.FC<DetailFilterSelectionInfoPropsType> = (props: DetailFilterSelectionInfoPropsType) => {
  const selectionInfo = useFragment(detailFilterSelectionInfoFragment, props.selectionInfo);

  return (
    <div className="pt-5 text-sm">
      {selectionInfo !== null
        ? [
            <span key={1} className="mr-2 inline-block">
              {`${props.filterCount} ${selectionInfo[props.filterCount === 1 ? 'resultTextSingular' : 'resultTextPlural']}`}
            </span>,
            props.hasResetOption
              ? [
                  <span key={2}>|</span>,
                  <button type="button" key={3} className="ml-2 inline-block cursor-pointer text-accent" onClick={props.resetHandlerFn.bind(null, null, null)}>
                    {selectionInfo.resetText}
                  </button>,
                ]
              : null,
          ]
        : null}
    </div>
  );
};

export { DetailFilterSelectionInfo };
